/* Whomie Club – delad scroll-indikator.
   Kopplar en list + tumme till en scrollbar rad.
   Markup: en behållare med data-whomie-scrollbar som innehåller
   [data-wscroll] (raden), [data-wtrack] (listen), [data-wthumb] (tummen). */
(function () {
  if (window.__whomieScrollbarInit) return;
  window.__whomieScrollbarInit = true;

  function wire(root) {
    if (!root || root.__wwired) return;
    var scroll = root.querySelector('[data-wscroll]');
    var track = root.querySelector('[data-wtrack]');
    var thumb = root.querySelector('[data-wthumb]');
    if (!scroll || !track || !thumb) return;
    root.__wwired = true;

    function update() {
      var sw = scroll.scrollWidth;
      var cw = scroll.clientWidth;
      if (sw <= cw + 1) {
        track.style.display = 'none';
        return;
      }
      track.style.display = '';
      var ratio = cw / sw;
      var thumbW = Math.max(ratio * 100, 8);
      var maxScroll = sw - cw;
      var progress = maxScroll > 0 ? scroll.scrollLeft / maxScroll : 0;
      thumb.style.width = thumbW + '%';
      thumb.style.marginLeft = (progress * (100 - thumbW)) + '%';
    }

    var ticking = false;
    scroll.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () { update(); ticking = false; });
        ticking = true;
      }
    }, { passive: true });

    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    if (window.ResizeObserver) {
      new ResizeObserver(update).observe(scroll);
    }

    /* Dra i tummen */
    thumb.style.cursor = 'grab';
    thumb.style.touchAction = 'none';
    var dragging = false, startX = 0, startScroll = 0;

    thumb.addEventListener('pointerdown', function (e) {
      dragging = true;
      startX = e.clientX;
      startScroll = scroll.scrollLeft;
      thumb.style.cursor = 'grabbing';
      try { thumb.setPointerCapture(e.pointerId); } catch (_) {}
      e.preventDefault();
    });

    thumb.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var maxScroll = scroll.scrollWidth - scroll.clientWidth;
      var travel = track.clientWidth - thumb.offsetWidth;
      var dx = e.clientX - startX;
      var delta = travel > 0 ? (dx / travel) * maxScroll : 0;
      scroll.scrollLeft = startScroll + delta;
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      thumb.style.cursor = 'grab';
      try { thumb.releasePointerCapture(e.pointerId); } catch (_) {}
    }
    thumb.addEventListener('pointerup', endDrag);
    thumb.addEventListener('pointercancel', endDrag);

    /* Klick på listen för att hoppa dit */
    track.addEventListener('pointerdown', function (e) {
      if (e.target === thumb) return;
      var rect = track.getBoundingClientRect();
      var maxScroll = scroll.scrollWidth - scroll.clientWidth;
      var tw = thumb.offsetWidth;
      var target = (e.clientX - rect.left - tw / 2) / (rect.width - tw);
      target = Math.max(0, Math.min(1, target));
      scroll.scrollTo({ left: target * maxScroll, behavior: 'smooth' });
    });

    update();
    setTimeout(update, 300);
  }

  function scan() {
    var roots = document.querySelectorAll('[data-whomie-scrollbar]');
    for (var i = 0; i < roots.length; i++) wire(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  /* Temaredigeraren: koppla om när en sektion laddas om */
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('[data-whomie-scrollbar]') : null;
    if (r) { r.__wwired = false; wire(r); }
    else scan();
  });
})();
